import { useContext, useEffect } from 'react';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { AppContext } from '../../../main/context/Provider';
import { AddButton } from '../../shared/components/AddButton';
import withFilteredRequestWithTypes from '../../shared/components/table/withFilteredRequestWithTypes';
import { CardProject } from '../components/card/CardProject';

export const ProjectPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const CardsList = withFilteredRequestWithTypes(
        'projects/projects-list',
        CardProject
    );
    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Proyectos');

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Proyectos',
                route: Private_Routes.PROJECT_PAGE,
            },
        ]);
    }, [lang]);

    return (
        <div className='row'>
            <div className='col-12'>
                <div className='card'>
                    <div className='card-body'>
                        <div className='mb-3'>
                            <AddButton href={Private_Routes.CREATE_PROJECT} />
                        </div>
                        <CardsList />
                    </div>
                </div>
            </div>
        </div>
    );
};
